module.exports = __webpack_public_path__ + "static/media/ShoppingList.55788b5f.png";